import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../layer/ILoaderProps';
import { LoadableSource } from '../../layer/LoadableSource';
import { Config } from '../../../Config';

const UrbanAreasCentral = (props: ILoaderProps) => 
  <LoadableSource path="https://apigeostore.longline.co.uk/dataset/6f7023be211c73673d476fa61b5a2590b958df6e" {...props}>
    <Layer
      id='urban_central'
      beforeId={Config.UI.before_layer}
      type='fill'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        "fill-color": "#d3d3d3",
        "fill-opacity": [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          0.8,
          0.5
          ]
      }}
    />
    <Layer
      beforeId={Config.UI.before_layer}
      type='line'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        "line-color": "black",
        "line-width": 0.5,
      }}
    />
  </LoadableSource>

export { UrbanAreasCentral } 
